import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages";
import { cloneDeep } from "lodash";
import { Subscription } from "rxjs";
import { CclDrawerService, CclNavbarFooterService, CclMessageService } from "certain-common-library";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../../modules/shared/services/catalog.service";
import { UnsavedChangesDeactivate } from "../../../../can-deactivate";

@Component({
    selector: "button-config",
    templateUrl: "./button-config.view.html",
    providers: []
})
export class ButtonConfigView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    catalogLayoutConfig: any = {};
    buttonConfig: any = {};
    sessionConfigObj: any = {};
    sessionConfig: any = {};
    iconList = {
        cart: [
            {
                label: "Cart",
                class: "fa-cart-arrow-down",
                secondaryClass: "fa-cart-arrow-down"
            },
            {
                label: "No Icon",
                class: "",
                secondaryClass: ""
            }
        ],
        fav: [
            {
                label: "Heart",
                class: "fa-heart",
                secondaryClass: "fa-heart-o"
            },
            {
                label: "Star",
                class: "fa-star",
                secondaryClass: "fa-star-o"
            },
            {
                label: "No Icon",
                class: "",
                secondaryClass: ""
            }
        ],
        remove: [
            {
                label: "Remove",
                class: "fa-times",
                secondaryClass: "fa-times"
            },
            {
                label: "Eye Slash",
                class: "fa-eye-slash",
                secondaryClass: "fa-eye-slash"
            },
            {
                label: "No Icon",
                class: "",
                secondaryClass: ""
            }
        ]
    };

    constructor(
        private drawerService: CclDrawerService,
        private _flashMessagesService: FlashMessagesService,
        public sharedService: SharedService,
        private catalogService: CatalogService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private activatedRoute: ActivatedRoute
    ) {
        super(sharedService);
        this.subscription = this.messageService.getMessage().subscribe(message => this.saveConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.sharedService.currentLayoutSection = "button-config";
        this.sessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.SESSION['general']];

        if (this.sessionConfigObj == null || this.sessionConfigObj.id == null) {
            this.sessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig.general);
            this.sessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.SESSION['general']
            };
        } else {
            this.sessionConfig = JSON.parse(this.sessionConfigObj.config);
            this.sharedService.sessionLayoutConfig.general = cloneDeep(this.sessionConfig);
        }

        this.sharedService.originalData = cloneDeep(this.sessionConfig);
        this.sharedService.changedData = this.sessionConfig;

        this.buttonConfig = this.sessionConfig.catalogConfig.buttonConfig;
        this.loadDefaultStyle();
    }

    private loadDefaultStyle() {
        if (!this.buttonConfig.removeScheduleButtonLabel) {
            this.buttonConfig.removeScheduleButtonLabel = "Cancel";
        }
        if (!this.buttonConfig.removeScheduleButtonBackground) {
            this.buttonConfig.removeScheduleButtonBackground = "#ffffff";
        }
        if (!this.buttonConfig.removeScheduleButtonColor) {
            this.buttonConfig.removeScheduleButtonColor = "#000000";
        }
        if (!this.buttonConfig.removeScheduleButtonStyle) {
            this.buttonConfig.removeScheduleButtonStyle = "bold";
        }

        if (!this.buttonConfig.calendarButtonLabel) {
            this.buttonConfig.calendarButtonLabel = "Add to Calendar";
        }
        if (!this.buttonConfig.calendarButtonBackground) {
            this.buttonConfig.calendarButtonBackground = "#ffffff";
        }
        if (!this.buttonConfig.calendarButtonColor) {
            this.buttonConfig.calendarButtonColor = "#000000";
        }
        if (!this.buttonConfig.calendarButtonStyle) {
            this.buttonConfig.calendarButtonStyle = "bold";
        }
    }

    iconChange(e, prop1, prop2, type) {
        this.buttonConfig[prop1] = e.value;
        this.iconList[type].forEach((element) => {
            if (element.class == e.value) {
                this.buttonConfig[prop2] = element.secondaryClass;
            }
        });
    }

    toggleAddToCartButton(e) {
        this.buttonConfig.enableAddToCartButton = !this.buttonConfig.enableAddToCartButton;
    }

    toggleAddToCalendarButton(e) {
        this.buttonConfig.enableAddToCalendarButton = !this.buttonConfig.enableAddToCalendarButton;
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (this.buttonConfig.enableAddToCalendarButton) {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Add To Calendar";
            } else if (this.catalogLayoutConfig.listType == "magazine") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Data for highlighted section";
            } else if (this.catalogLayoutConfig.listType == "promoted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Data for promoted section";
            } else {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Data for general section";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-button-config";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-button-config";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    saveConfig(message) {
        if (message.text == "save-button-config" || message.text == "save-next-button-config") {
            this.sessionConfig.catalogConfig.buttonConfig = this.buttonConfig;
            this.sessionConfigObj.config = JSON.stringify(this.sessionConfig);

            this.catalogService.saveSetupConfig(this.sessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.sessionConfig);
                this.sharedService.changedData = this.sessionConfig;

                this.sessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                if(this.sharedService.setup.setupConfigs && this.sharedService.setup.setupConfigs.length>0) {
                    let index = this.sharedService.setup.setupConfigs.findIndex(elem => elem.id === this.sessionConfigObj.id);
                    this.sharedService.setup.setupConfigs[index] = this.sessionConfigObj;
                }
                this.sharedService.configs[this.sharedService.configTypes.SESSION['general']] = this.sessionConfigObj;
                this._flashMessagesService.show(
                    "Edit Buttons & Icons saved successfully.",
                    {
                        cssClass: "alert-success"
                    }
                );
                this.messageService.sendMessage("update-setting");
                if (message.text == "save-next-button-config") {
                    if (this.buttonConfig.enableAddToCalendarButton) {
                        this.sharedService.catalogNavigateHelper("admin", "catalog/add-setting/add-to-calendar-config");
                    } else {
                        this.sharedService.catalogNavigateHelper("admin", "catalog/add-setting/rules-validation-config");
                    }
                }
            });
        }
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }
}
